import type { CurrentDrupalUserFragment } from '#graphql-operations'

export interface DrupalUser {
  hasSessionCookie: boolean
  fetched: boolean
  user?: CurrentDrupalUserFragment | null
}

type UseDrupalUser = {
  /**
   * Whether the user can access the toolbar.
   */
  canAccessToolbar: boolean
}

export default async function (): Promise<UseDrupalUser> {
  const headers = useRequestHeaders()
  const state = useState<DrupalUser>('drupalUser', () => {
    const hasSessionCookie = import.meta.server
      ? (headers.cookie || '').includes('SSESS')
      : true
    return {
      hasSessionCookie,
      // If there is no session cookie, we can set fetched to true, since there
      // is no need to actually fetch the user data.
      fetched: !hasSessionCookie,
      user: null,
    }
  })

  // Only load the user data when not already done.
  if (!state.value.fetched && import.meta.client) {
    const data = await useGraphqlQuery('drupalUser')
    state.value.fetched = true
    state.value.user = data.data.currentDrupalUser
  }

  const canAccessToolbar = !!state.value.user?.canAccessToolbar

  return {
    canAccessToolbar,
  }
}
